/** Created by azhou on 2019/3/19.*/
<template>
  <div>
    <ul class="list-item">
        <li class="w-50 list-item-col">{{Itemize.name}}</li>
        <li class="w-50 list-item-col">{{Itemize.tag_id | formatVar('BMealType')}}</li>
        <li class="w-50 list-item-col">{{Itemize.price}}/{{Itemize.price_type | formatVar('EateryType')}}</li>
        <li class="w-50 list-item-col">{{Itemize.time | formatTimestamp(1)}}</li>
        <li class="w-50 list-item-col">
            <label :class="Itemize.status == 0 ? 'text-danger' : 'text-success'">
            {{Itemize.status == 1 ? '启用中' : '已下架'}}
            <span class="text-blue cursor-pointer" @click="changeStatus(item)">（{{Itemize.status == 1 ? '下架' : '上架'}}）</span>
            </label>
        </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'ItemizeRestaurant',
    props:{
      Itemize:{}
    },
  }
</script>
